import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#arrowLeft'
const _hoisted_2 = _imports_0 + '#searchBtn'
const _hoisted_3 = { class: "catalog" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "catalog__container" }
const _hoisted_6 = { class: "catalog__header" }
const _hoisted_7 = { class: "catalog__header-left" }
const _hoisted_8 = {
  key: 0,
  class: "catalog__categories"
}
const _hoisted_9 = { class: "catalog__categories-icon" }
const _hoisted_10 = {
  width: "28",
  height: "28"
}
const _hoisted_11 = ["xlink:href"]
const _hoisted_12 = {
  key: 2,
  class: "loader"
}
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "catalog__list" }

import router from "@/router";
  import { computed, ref, watch } from "vue";
  import sprite from "@/assets/icons/sprite.svg";
  import Tags from "@/components/Tags.vue";
  import Card from "@/components/Card.vue";
  import CartModal from "@/components/CartModal.vue";
  import { IPagination, IProduct, ISection, ISectionsItem } from "@/models/models";
  import Pagination from "@/components/Pagination.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Catalog',
  props: ["data"],
  setup(__props) {

  const props = __props;

  const iconPath = computed(() => `${sprite}#saus`);

  const items = ref<Array<IProduct>>([] as Array<IProduct>);

  const section = ref<ISection>({} as ISection);

  const sectionDetail = ref<Array<ISectionsItem>>([] as Array<ISectionsItem>);

  const pagination = ref<IPagination>({} as IPagination);

  const isLoading = ref(false);

  let isShowMore: boolean = false;

  const getData = () => {
    if (!isShowMore) {
      isLoading.value = true;
    }

    fetch(
      `https://akshop.a-dev.xyz/api/v1/catalog/products?sectionId=${
        router.currentRoute.value.params.name
      }&${new URLSearchParams(
        router.currentRoute.value.query as Record<string, string>
      )}`
    )
      .then((response) => response.json())
      .then((data) => {
        section.value = data.section;
        pagination.value = data.pagination;

        if (isShowMore) {
          items.value = [...data.items, ...items.value];
          isShowMore = false;
        } else {
          items.value = data.items;
        }

        return data;
      })
      .then((data) => {
        fetch(`https://akshop.a-dev.xyz/api/v1/sections/${data.section.id}`)
          .then((response) => response.json())
          .then((data) => {
            sectionDetail.value = data.sections;
            isLoading.value = false;
          });
      });
  };

  const showMore = (page: number) => {
    isShowMore = true;
    router.push({
      path: router.currentRoute.value.path,
      params: router.currentRoute.value.params,
      query: { ...router.currentRoute.value.query, ...{ page: page } },
    });
  };

  getData();

  watch(
    () => router.currentRoute.value,
    async (newVal, oldVal) => {
      if ((oldVal && newVal.path == oldVal.path) || oldVal == undefined) {
        getData();
      }
    },
    {
      deep: true,
      immediate: false,
    }
  );

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
                class: "catalog__back"
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  width: "8",
                  height: "12"
                }, [
                  _createElementVNode("use", { "xlink:href": _hoisted_1 })
                ], -1)
              ])),
              _createElementVNode("h1", null, _toDisplayString(section.value.name), 1)
            ]),
            _createVNode(_component_RouterLink, { to: "/search" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  width: "36",
                  height: "36"
                }, [
                  _createElementVNode("use", { "xlink:href": _hoisted_2 })
                ], -1)
              ])),
              _: 1
            })
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                    _createElementVNode("use", { "xlink:href": iconPath.value }, null, 8, _hoisted_11)
                  ]))
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "catalog__categories-content" }, [
                  _createElementVNode("div", { class: "catalog__categories-title" }, "Молоко, сыры,яйцо"),
                  _createElementVNode("div", { class: "catalog__categories-text" }, "523 товара")
                ], -1))
              ]))
            : _createCommentVNode("", true),
          (sectionDetail.value.length > 0)
            ? (_openBlock(), _createBlock(Tags, {
                key: 1,
                class: "catalog__tags",
                data: sectionDetail.value
              }, null, 8, ["data"]))
            : _createCommentVNode("", true),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "loader-spinner" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                    return (_openBlock(), _createBlock(Card, { data: item }, null, 8, ["data"]))
                  }), 256))
                ]),
                _createElementVNode("div", null, [
                  _createVNode(Pagination, {
                    source: pagination.value,
                    onShowMore: showMore
                  }, null, 8, ["source"])
                ])
              ]))
        ])
      ])
    ]),
    _createVNode(CartModal)
  ], 64))
}
}

})